/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreDTOsMatchGameTimelineDtoSchema } from "./matchGameTimelineDtoSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreDTOsMatchTimelineDtoSchema = z.object({
  matchId: z.string().nullish(),
  get games() {
    return z.array(goodLuckCoreDTOsMatchGameTimelineDtoSchema).nullish();
  },
});
